<template>
  <div>
    <div id="bread">
      <span class="hidden-xs">你现在的位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          v-for="(item, index) in menuList"
          :key="index"
          :to="{ path: item.path === '' ? '/' : item.path }"
        >
          <a v-if="item.path">
            {{ item.meta.title }}
          </a>
          <a @click="goIndex" v-else> 首页 </a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
export default {
  name: "Bread",
  data() {
    return {
      obj: {
        path: "/home",
        name: "home",
        meta: {
          title: "首页",
        },
      },
      breadList: [
        {
          path: "/home",
          name: "home",
          meta: {
            title: "首页",
          },
        },
      ],
    };
  },
  computed: {
    menuList() {
      return this.$store.state.menuList;
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      this.name = this.$route.name;
      const list = this.$route.matched.filter((item, index) => {
        return index !== 1;
      });
      this.$store.commit("SET_MENULISTCHANGE", list);
    },
    goIndex() {
      // 更新状态管理
      sessionStorage.setItem("navIndex", 0);
      this.$store.commit("SET_NUM_INDEX", 0);
    },
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
};
</script>
<style scoped>
#bread {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
#bread a {
  text-decoration: none;
}
@media screen and (max-width: 767px) {
  #bread {
    justify-content: flex-start;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Bread.vue